<template>
    <div class="card">
        <h3 v-if="title">{{title}}</h3>
        <div class="card-body">
            <div class="row">
                <div class="col-12 form-group">
                    <span class="float-right">
                        <person-search :person-search-type="personSearchType"
                                       :expanded="true"
                                       :showId="showId"
                                       :includeMergedProfiles="includeMergedProfiles"
                                       @onPersonSelected="onPersonSelected"
                                        :show-modal="showModal">
                        </person-search>
                    </span>
                </div>
                <div class="loader" v-if="loading"></div>
                <div class="col-12" v-else>
                    <div v-if="person != null">
                        <person-details-card v-model="person" :hideBtns="true" :hideFooter="true">
                        </person-details-card>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Person } from '../../models/models';
    import PersonDetailsCard from './PersonDetailsCard';
    import PersonSearch from '../common/PersonSearch';
    import { PersonSearchType } from '../../models/enums';
    import personService from '../../services/person.service';

    export default {
        props: {
            title: String,
            personSearchType: {
                type: [Number, String],
                default: PersonSearchType.Person
            },
            show: {
                type: Boolean,
                default: false
            },
            showId: {
                type: Boolean,
                default: false
            },
            includeMergedProfiles: {
                type: Boolean,
                default: false
            },
            showModal: {
                type: Boolean,
                default: false
            }
        },
        components: {
            PersonSearch,
            PersonDetailsCard
        },
        data() {
            return {
                person: {
                    type: Person,
                    default: null
                },
                loading: false,
            };
        },
        mounted() {
        },
        methods: {
            loadPerson(id) {
                this.loading = true;
                personService
                    .getById(id)
                    .then(response => {
                        let model = response.data;
                        if (model) {
                            this.person = new Person(model);
                        } else {
                            this.person = null;
                        }

                        this.loading = false;
                        this.$emit('personSelected', this.person)
                    })
                    .catch(error => {
                        this.loading = false;
                        this.person = null;

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            onPersonSelected(personSearchModel) {
                if (this.person != null && this.person.id === personSearchModel.id) {
                    return;
                }

                this.loadPerson(personSearchModel.id);
            },
            clearPerson() {
                this.person = null;
            }
        },
        watch: {
            show: function (val) {
                this.clearPerson();
            }
        },
        computed: {
        }
    };
</script>

<style scoped>
</style>
